module.exports = __webpack_public_path__ + "static/media/guanyinshan_web.b9703473.webp";